import { httpClient } from '../../../services/http/httpClient.js';

const VEHICLES_API_URL = '/api/seguimiento/vehicles';

const getVehiclesCollection = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.vehicles)) {
    return payload.vehicles;
  }

  return [];
};

const hasValidCoordinates = (vehicle) => {
  return vehicle?.latitude
    && vehicle?.longitude
    && !Number.isNaN(parseFloat(vehicle.latitude))
    && !Number.isNaN(parseFloat(vehicle.longitude));
};

export const teamVehicleService = {
  getVehicles: async () => {
    const payload = await httpClient.get(VEHICLES_API_URL);
    return getVehiclesCollection(payload);
  },

  getVehiclesWithLocation: async () => {
    const vehicles = await teamVehicleService.getVehicles();
    return vehicles.filter(hasValidCoordinates);
  },

  reverseGeocode: async (lat, lng) => {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`;
    const payload = await httpClient.get(url, { auth: false });
    return payload?.display_name || `${lat}, ${lng}`;
  }
};
